import MuiToolbar, { ToolbarProps } from '@mui/material/Toolbar';

export interface IToolbarProps extends ToolbarProps {}

const Toolbar = (props: IToolbarProps): JSX.Element => {
  return <MuiToolbar {...props} />;
};

export default Toolbar;
